<template>
  <el-dialog :title="selectDetail.title" :visible.sync="showDialog" width="600px" :destroy-on-close="true" :append-to-body="true"
             :before-close="cancel">
    <el-form :model="form" ref="updateProjectInfoForm" label-width="70px">
      <template v-for="key in  Object.keys(form)">
        <el-form-item :label="form[key].label" >
          <el-input v-if="form[key].type==='textarea'"
                    type="textarea"
                    v-model="form[key].value"
                    maxlength="100"
                    :placeholder="'请输入'+form[key].label" show-word-limit
                    rows="4" >
          </el-input>
          <el-input v-else v-model="form[key].value" :placeholder="'请输入'+form[key].label"></el-input>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handle">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "EditFormInfoDialog",
  props: {
    showDialog: {
      default: false
    },
    selectDetail:{
      default: ()=>({
        title:'编辑信息',
        form:[]
      })
    }
  },
  watch:{
   'selectDetail.form':{
     handler:function (newVal) {
       if(newVal){
         this.form=JSON.parse(JSON.stringify(newVal))
       }

     },
     immediate:true
   }
  },
  data(){
    return{
      form:{

      }
    }
  },
  methods: {
    cancel() {
      this.$emit('update:showDialog')
    },
    handle() {
      this.$emit('submitData',{
        ...this.selectDetail,
        form:JSON.parse(JSON.stringify(this.form))
      })
    },
  },
}
</script>

<style scoped>

</style>
